import { createRoot } from "react-dom/client";
import App from "./components/App";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { registerServiceWorker } from "./sw-register";
import "./tailwind.css";
import "./styles/tokens.css";

function renderFatalError(error) {
  const container = document.getElementById("root");
  if (!container) return;
  container.innerHTML = `
    <div style="position:fixed;top:0;left:0;width:100vw;height:100vh;background:#f8f9fa;display:flex;align-items:center;justify-content:center;font-family:Inter,-apple-system,BlinkMacSystemFont,sans-serif">
      <div style="background:#fff;border-radius:12px;padding:32px;width:480px;max-width:90vw;box-shadow:0 4px 24px rgba(0,0,0,0.12);text-align:center">
        <div style="width:48px;height:48px;background:#FEE4E2;border-radius:999px;display:flex;align-items:center;justify-content:center;font-size:22px;margin:0 auto 20px">&#9888;</div>
        <h2 style="font-size:18px;font-weight:600;color:#101828;margin-bottom:8px">POS Failed to Start</h2>
        <p style="font-size:14px;color:#475467;margin-bottom:16px">The application could not initialize. This is usually caused by corrupted cache data.</p>
        <div style="background:#FEF3F2;border:1px solid #FEE4E2;border-radius:6px;padding:8px 12px;font-size:12px;color:#B42318;margin-bottom:20px;word-break:break-word;max-height:60px;overflow:auto">${error?.message || "Unknown startup error"}</div>
        <div style="display:flex;gap:8px;justify-content:center">
          <button onclick="try{localStorage.clear()}catch(e){}window.location.href='/sign-in'" style="background:#fff;border:1px solid #D0D5DD;color:#344054;padding:8px 14px;font-size:13px;font-weight:500;border-radius:8px;cursor:pointer">Go to Login</button>
          <button onclick="try{var k=['authTokens','oAuthData'];var p={};k.forEach(function(x){var v=localStorage.getItem(x);if(v)p[x]=v});localStorage.clear();Object.entries(p).forEach(function(e){localStorage.setItem(e[0],e[1])})}catch(e){}window.location.href='/till'" style="background:#FEF3F2;border:1px solid #FEE4E2;color:#B42318;padding:8px 14px;font-size:13px;font-weight:500;border-radius:8px;cursor:pointer">Clear Cache & Reload</button>
          <button onclick="window.location.reload()" style="background:#2970FF;border:none;color:#fff;padding:8px 14px;font-size:13px;font-weight:500;border-radius:8px;cursor:pointer">Reload POS</button>
        </div>
      </div>
    </div>`;
}

window.addEventListener("error", (event) => {
  if (event.error && !document.querySelector("[data-error-boundary]")) {
    console.error("[POS] Uncaught error:", event.error);
    renderFatalError(event.error);
  }
});

try {
  const root = createRoot(document.getElementById("root"));
  root.render(
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  );
} catch (error) {
  console.error("[POS] Fatal startup error:", error);
  renderFatalError(error);
}

registerServiceWorker();
